"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const kendo_react_grid_1 = require("@progress/kendo-react-grid");
const grid_style_1 = __importDefault(require("./grid.style"));
const pit_operation_action_1 = __importDefault(require("../../pit-operation.action"));
const pit_operation_style_1 = __importDefault(require("../../pit-operation.style"));
const store_1 = require("store");
const input_1 = require("components/atoms/input");
const constants_1 = require("utils/constants");
const pagination_1 = __importDefault(require("components/templates/pagination"));
const typography_1 = require("components/atoms/typography");
const card_1 = require("components/molecules/card");
function isFilterDescriptor(f) {
    return 'operator' in f;
}
const GridComponent = (_a) => {
    var { dataStates, style, columns, onTakeChange, onPageChange, onFilterChange, pageable, fullScreen } = _a, props = __rest(_a, ["dataStates", "style", "columns", "onTakeChange", "onPageChange", "onFilterChange", "pageable", "fullScreen"]);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { appTheme } = (0, store_1.useAppSelector)(state => state.app);
    const { dataGrid, filterChild, isLoading, } = (0, store_1.useAppSelector)(state => state.configuration.pitOperation);
    const [rowheight, setRowHeight] = (0, react_1.useState)(20);
    const [searchTerm, setSearchTerm] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        const delayDebounceFn = setTimeout(() => {
            if (!isLoading)
                dispatch(pit_operation_action_1.default.onFilterChild({ filterChild: searchTerm }));
        }, 300);
        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);
    (0, react_1.useEffect)(() => {
        if (filterChild === '') {
            setSearchTerm('');
        }
    }, [filterChild]);
    (0, react_1.useEffect)(() => {
        const [gridElement] = document.getElementsByClassName('k-widget k-grid no-scrollbar');
        if (gridElement) {
            const containerHeight = gridElement.clientHeight;
            const height = containerHeight / (dataGrid.length + 3);
            setRowHeight(height < 30 ? undefined : height);
            if (dataGrid.length < 10)
                setRowHeight(40);
        }
    }, [dataGrid]);
    const pageSize = dataStates.take > dataGrid.length ? dataGrid.length : dataStates.take;
    const pagination = (props) => {
        return (0, jsx_runtime_1.jsx)(pagination_1.default, Object.assign({}, props, { onPageChange: onPageChange, onTakeChange: onTakeChange }));
    };
    const nativeOnFilterChange = (e) => {
        const filters = [];
        if (e.filter) {
            e.filter.filters.forEach(item => {
                if (isFilterDescriptor(item)) {
                    filters.push(item);
                }
            });
            const filterEvent = Object.assign(Object.assign({}, e), { filter: Object.assign(Object.assign({}, e.filter), { filters }) });
            if (onFilterChange) {
                onFilterChange(filterEvent);
            }
        }
        else {
            const filterEvent = Object.assign(Object.assign({}, e), { filter: undefined });
            if (onFilterChange) {
                onFilterChange(filterEvent);
            }
        }
    };
    // Custom Cell for Status (Active/Inactive) Column
    const _statusCell = (props) => ((0, jsx_runtime_1.jsx)("td", Object.assign({ id: `m_grid_cell_is_active_${props.dataIndex}` }, { children: props.dataItem.is_active ? 'Active' : 'Inactive' })));
    const DetailComponent = (props) => {
        const data = props.dataItem.dataChild;
        if (data) {
            return ((0, jsx_runtime_1.jsxs)(kendo_react_grid_1.Grid, Object.assign({ data: data, style: { marginLeft: 55 } }, { children: [(0, jsx_runtime_1.jsx)(kendo_react_grid_1.GridColumn, { field: 'dumptruck_no', title: 'Dump Truck No', width: 400 }), (0, jsx_runtime_1.jsx)(kendo_react_grid_1.GridColumn, { field: 'capacity_volume', title: 'Capacity Volume', width: 350 }), (0, jsx_runtime_1.jsx)(kendo_react_grid_1.GridColumn, { field: '', title: '' })] })));
        }
        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: {
                height: '50px',
                width: '100%',
            } }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ style: {
                    position: 'absolute',
                    width: '100%',
                } }, { children: (0, jsx_runtime_1.jsx)("div", { className: 'k-loading-image' }) })) })));
    };
    return ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: (0, jsx_runtime_1.jsx)(card_1.Card, Object.assign({ style: grid_style_1.default.cardGridStyle(appTheme) }, { children: (0, jsx_runtime_1.jsxs)(card_1.CardBody, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ style: pit_operation_style_1.default.searchWrapper }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: pit_operation_style_1.default.search }, { children: [(0, jsx_runtime_1.jsx)(typography_1.Typography, Object.assign({ style: pit_operation_style_1.default.searchTypograph(appTheme), typographyType: 'bold' }, { children: 'Dump Truck Search' })), (0, jsx_runtime_1.jsx)(input_1.Input, { className: appTheme, style: pit_operation_style_1.default.inputSearch, value: searchTerm, onChange: e => {
                                        setSearchTerm(e.target.value);
                                    } })] })) })), (0, jsx_runtime_1.jsx)(kendo_react_grid_1.Grid, Object.assign({ data: dataGrid, detail: DetailComponent, expandField: 'expanded', selectedField: 'expanded', 
                        // onExpandChange={expandChange}
                        rowHeight: rowheight, scrollable: dataStates.scrollable, pageSize: pageSize, take: dataStates.take, total: dataStates.total, skip: dataStates.skip, className: fullScreen ? 'no-scrollbar full-scren-grid' : 'no-scrollbar', style: style, sortable: dataStates.sortable, filterable: dataStates.filterable, reorderable: dataStates.reorderable, filter: dataStates.filter, sort: dataStates.sort, pageable: pageable, filterOperators: constants_1.customFilterOperator, pager: pageable ? pagination : undefined, onFilterChange: nativeOnFilterChange }, props, { children: columns.filter(x => x.show).map((column, index) => {
                            var _a;
                            return (((_a = column.field) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'is_active' ? ((0, jsx_runtime_1.jsx)(kendo_react_grid_1.GridColumn, Object.assign({ cell: _statusCell }, column), index)) : ((0, jsx_runtime_1.jsx)(kendo_react_grid_1.GridColumn, Object.assign({}, column), index)));
                        }) }))] }) })) }));
};
exports.default = GridComponent;
